<template>
  <mobile-responsive-shell :title="title">
    <div class="credit-mobile">
      <div class="credit-mobile-toolbar">
        <button type="button" class="btn btn-outline-secondary btn-sm" @click="refresh">
          <i class="bi bi-arrow-clockwise"></i> Actualiser
        </button>
        <button type="button" class="btn btn-outline-secondary btn-sm" @click="print">
          <i class="bi bi-printer"></i> Imprimer
        </button>
      </div>

      <p v-if="!credits || credits.length === 0" class="credit-mobile-empty text-muted">
        Aucune ligne pour ce client.
      </p>

      <div v-else class="credit-mobile-list">
        <article
          v-for="(credit, idx) in credits"
          :key="credit.reference || idx"
          class="credit-mobile-card credit-mobile-detail-card"
        >
          <div class="credit-mobile-detail-row">
            <span class="credit-mobile-label">Réf.</span>
            <span>{{ credit.customer_reference }}</span>
          </div>
          <div class="credit-mobile-detail-row">
            <span class="credit-mobile-label">Client</span>
            <span>{{ credit.customer ? credit.customer.fullName : "—" }}</span>
          </div>
          <div class="credit-mobile-detail-row">
            <span class="credit-mobile-label">Montant</span>
            <strong>{{ formatNum(credit.amount) }}</strong>
          </div>
          <div class="credit-mobile-detail-row">
            <span class="credit-mobile-label">Date</span>
            <span>{{ credit.date }}</span>
          </div>
          <div class="credit-mobile-detail-row">
            <span class="credit-mobile-label">Vente</span>
            <span class="text-break">{{ credit.sale_reference || "—" }}</span>
          </div>
          <div class="credit-mobile-detail-row">
            <span class="credit-mobile-label">Paiement</span>
            <span class="text-break">{{ credit.payment_reference || "—" }}</span>
          </div>
          <div class="credit-mobile-detail-row">
            <span class="credit-mobile-label">Statut</span>
            <span class="badge bg-secondary">En attente</span>
          </div>

          <div class="credit-mobile-actions">
            <button
              type="button"
              class="btn btn-primary btn-sm flex-fill"
              @click="paySale(credit.reference)"
            >
              Régler facture
            </button>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm flex-fill"
              @click="refund(credit.reference)"
            >
              Remboursement
            </button>
          </div>
        </article>
      </div>
    </div>
  </mobile-responsive-shell>
</template>

<script>
import { mapGetters } from "vuex";
import MobileResponsiveShell from "../components/MobileResponsiveShell.vue";

export default {
  name: "MobileCreditsBalanceDetails",
  components: { MobileResponsiveShell },
  data() {
    return {
      title: "Détail soldes client",
    };
  },
  computed: {
    ...mapGetters("credit", {
      credits: "getAll",
    }),
  },
  mounted() {
    this.$store.dispatch(
      "credit/getCustomerCreditBalance",
      this.$route.params.customer_reference
    );
  },
  methods: {
    formatNum(v) {
      const n = parseFloat(v);
      if (Number.isNaN(n)) return "—";
      return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    refresh() {
      this.$store.dispatch(
        "credit/getCustomerCreditBalance",
        this.$route.params.customer_reference
      );
    },
    print() {
      window.print();
    },
    paySale(reference) {
      this.$store.dispatch("credit/paySale", reference);
    },
    refund(reference) {
      this.$store.dispatch("credit/refund", reference);
    },
  },
};
</script>

<style scoped>
.credit-mobile-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.credit-mobile-empty {
  text-align: center;
  padding: 2rem 1rem;
}
.credit-mobile-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.credit-mobile-detail-card {
  background: #fff;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.credit-mobile-detail-row {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.35rem 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 1.05rem;
}
.credit-mobile-detail-row:last-of-type {
  border-bottom: none;
}
.credit-mobile-label {
  color: #6c757d;
  font-size: 0.88rem;
  text-transform: uppercase;
  flex-shrink: 0;
}
.credit-mobile-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #eee;
}
</style>
